import { Component, OnInit } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'app-date-picker',
  template: `
    <p-calendar
      [ngModel]="validDate"
      (ngModelChange)="onDateChange($event)"
      [dateFormat]="'mm-dd-yy'"
      [placeholder]="'MM-dd-yyyy'"
      [showIcon]="true"
    ></p-calendar>
  `,
})
export class DatePickerComponent extends FieldType implements OnInit {
  validDate: Date | null = null;

  ngOnInit(): void {
    this.validateDate();
  }

  validateDate(): void {
    const value = this.formControl.value;

    if (value instanceof Date && !isNaN(value.getTime())) {
      this.validDate = value;
    } else if (typeof value === 'string') {
      // Handle ISO format and other string dates
      const parsedDate = new Date(value);
      if (!isNaN(parsedDate.getTime())) {
        this.validDate = parsedDate;
      } else {
        console.warn('Invalid date format:', value);
        this.validDate = null; // Fallback to null
      }
    } else {
      console.warn('Invalid date value:', value);
      this.validDate = null; // Fallback to null
    }
  }

  onDateChange(event: any): void {
    if (event instanceof Date && !isNaN(event.getTime())) {
      this.formControl.setValue(event.toISOString()); // Store as ISO string
    } else {
      console.warn('Invalid date selected:', event);
      this.formControl.setValue(null);
    }
  }
}
